/* Ultra Rewards: cart drawer loyalty message (snippets/ur-cart-loyalty.liquid). Needs ur-rivo.js. */
(() => {
    if (window.urCartLoyalty || !window.urRivo) return;
    window.urCartLoyalty = true;

    const {
        whenReady,
        formatMoney,
        currencyRate,
        toShopCents,
        estimatePoints,
        spendToNextTier
    } = window.urRivo;
    let rivoCustomer = null;

    const renderPoints = (root) => {
        const spendTotal = Number(root.dataset.spendTotal) || 0;
        const earnRate = Number(root.dataset.earnRate) || 15;
        const key = `${spendTotal}:${earnRate}`;
        if (root.dataset.urPointsRendered === key) return;
        root.dataset.urPointsRendered = key;

        const points = estimatePoints(spendTotal, earnRate).toLocaleString(
            "en-AU"
        );
        root.querySelectorAll("[data-ur-cart-points]").forEach((el) => {
            if (el.textContent !== points) el.textContent = points;
        });
    };

    const renderTier = (root) => {
        const el = root.querySelector("[data-ur-cart-tier]");
        if (!el || !rivoCustomer) return;

        const spendTotal = Number(root.dataset.spendTotal) || 0;
        const key = String(spendTotal);
        if (el.dataset.urRendered === key) return;
        el.dataset.urRendered = key;

        const info = rivoCustomer.current_vip_tier_info;
        const nextTier = info?.next_tier;
        const toSpend = spendToNextTier(nextTier);

        if (
            !info ||
            info.highest_tier === true ||
            !nextTier?.name ||
            toSpend === null ||
            toSpend <= 0
        ) {
            el.hidden = true;
            return;
        }

        const gapShopCents = toSpend * 100 - toShopCents(spendTotal);

        el.textContent =
            gapShopCents > 0
                ? (el.dataset.copyGap ?? "")
                      .replace(
                          "[amount]",
                          formatMoney(
                              gapShopCents * currencyRate(),
                              el.dataset.moneySample
                          )
                      )
                      .replace("[tier]", nextTier.name)
                : (el.dataset.copyUnlock ?? "").replace(
                      "[tier]",
                      nextTier.name
                  );
        el.hidden = false;
    };

    const render = () => {
        document.querySelectorAll("[data-ur-cart-loyalty]").forEach((root) => {
            renderPoints(root);
            renderTier(root);
        });
    };

    const init = async () => {
        const drawer = document.getElementById("cart-drawer");
        if (!drawer) return;

        new MutationObserver(render).observe(drawer, {
            childList: true,
            subtree: true
        });
        document.addEventListener("theme:cart:added", render);
        document.addEventListener("theme:cart:open", render);
        render();

        rivoCustomer = await whenReady();
        render();
    };

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }
})();
